<div class="admin-container" #container>
  <p-confirmDialog [appendTo]="container"></p-confirmDialog>
  <div class="tags">
    <p-table #dt [value]="tags | async" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
      styleClass="p-datatable-gridlines" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="[10,25,50]" [globalFilterFields]="['tagString']">
      <ng-template pTemplate="caption">
        <div class="header">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="searchTag($event.target)" placeholder="Search keyword" />
          </span>
          <span>
            <input pInputText type="text" />
            <button pButton (click)="createTag()">Sauver</button>
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name">
            Nom<p-sortIcon field="name"></p-sortIcon>
          </th>
          <th [width]="'100px'"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-tag>
        <tr>
          <td>{{tag.tagString}}</td>
          <td class="actions">
            <button pButton class="update" (click)="updateTag(tag)">
              <i class="pi pi-pencil"></i>
            </button>
            <button pButton class="delete" (click)="deleteTag(tag)">
              <i class="pi pi-trash"></i>
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <p-dialog [(visible)]="update" [style]="{width: '30vw'}">
    <div class="modal" *ngIf="updateTagModel">
      <form class="form">
        <div class="form-group">
          <label>Tag</label>
          <input pInputText type="text" [(ngModel)]="updateTagModel.tagString" name="string">
        </div>
        <div class="submit">
          <button pButton class="p-button-sm" (click)="update = false" label="Annuler"></button>
          <button pButton class="p-button-sm" (click)="saveTag()" label="Sauver"></button>
        </div>
      </form>
    </div>
  </p-dialog>
</div>